var STATUS = {
  PENDING: "Em Andamento",
  COMPLETED: "Concluída",
  COMPLETED_LATE: "Concluída com Atraso",
  LATE: "Atrasada",
  CANCELED: "Cancelada"
}

export default STATUS